import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { PRICING_FEATURES } from "../data/content";

export const Pricing = () => {
  return (
    <section id="prezzi" className="py-20 sm:py-28" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand">Prezzi</span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-brand-deep">
            Un canone fisso. Nessuna sorpresa.
          </h2>
          <p className="mt-4 font-body text-base sm:text-lg text-ink leading-relaxed">
            Paghi un abbonamento chiaro, <b className="text-brand-deep">senza commissioni sulle vendite</b>.
            Tutto incluso, dalla configurazione all'assistenza.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-14 mx-auto max-w-4xl overflow-hidden rounded-[2rem] border border-gray-100 shadow-xl shadow-brand/5 grid md:grid-cols-2"
        >
          <div className="p-8 sm:p-10">
            <h3 className="font-heading text-2xl font-bold text-brand-deep">Piano PushApp</h3>
            <p className="mt-2 font-body text-ink">La tua web app, completa e personalizzata.</p>
            <div className="mt-6 flex items-end gap-2">
              <span className="font-heading text-4xl font-extrabold text-brand">Canone fisso</span>
            </div>
            <p className="mt-1 font-body text-sm text-ink/70">Zero commissioni sulle vendite</p>

            <ul className="mt-7 space-y-3">
              {PRICING_FEATURES.map((f) => (
                <li key={f} className="flex items-start gap-3 font-body text-ink">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand-green/15 text-brand-green">
                    <Check size={13} strokeWidth={3} />
                  </span>
                  {f}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-gradient-to-br from-brand to-brand-green p-8 sm:p-10 flex flex-col justify-center text-white">
            <h3 className="font-heading text-2xl font-bold">Vuoi una quotazione su misura?</h3>
            <p className="mt-3 font-body text-white/90 leading-relaxed">
              Raccontaci la tua attività: ti prepariamo una demo gratuita e ti diciamo
              esattamente quanto costa partire. Senza impegno.
            </p>
            <Link
              to="/assistenza"
              data-testid="pricing-cta-button"
              className="mt-7 inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 font-body font-semibold text-brand shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              Richiedi la tua demo <ArrowRight size={18} strokeWidth={2.5} />
            </Link>
            <p className="mt-4 font-body text-sm text-white/80">⚡ L'app è già pronta: parti in pochi giorni.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
